package ru.villawonka.app.presentation.design.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.theme.AppColors
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.surfaceMiddle
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_nav_arrow_down_24


@OptIn(ExperimentalMaterialApi::class)
@Composable
fun AppDropdownTextField(
    placeholder: String,
    selectedItem: String?,
    items: Set<String>,
    onValueChanged: (String) -> Unit,
) {
    var expanded by remember { mutableStateOf(false) }

    ExposedDropdownMenuBox(
        expanded = expanded,
        onExpandedChange = {
            if (items.isNotEmpty()) {
                expanded = !expanded
            }
        }
    ) {
        AppTextField(
            readOnly = true,
            placeholder = placeholder,
            value = selectedItem ?: "",
            trailingIcon = Res.drawable.ic_nav_arrow_down_24,
            onValueChange = {},
        )
        ExposedDropdownMenu(
            expanded = expanded,
            modifier = Modifier
                .background(
                    color = MaterialTheme.colors.surfaceMiddle,
                )
                .border(
                    width = 1.dp,
                    color = MaterialTheme.colors.filledMenuOutline,
                    shape = RoundedCornerShape(8.dp)
                )
                .clip(RoundedCornerShape(8.dp)),
            onDismissRequest = {
                expanded = false
            }
        ) {
            items.forEach {
                DropdownMenuItem(
                    onClick = {
                        expanded = false
                        onValueChanged(it)
                    }
                ) {
                    Text(
                        text = it,
                        style = AppTextStyles.labelMediumRegular,
                        color = MaterialTheme.colors.filledMenuContentEnabled
                    )
                }
            }
        }
    }
}

val Colors.filledMenuContentEnabled: Color
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50

val Colors.filledMenuContentHovered: Color
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50

val Colors.filledMenuContentFocused: Color
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50

val Colors.filledMenuContentDisabled: Color
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50


val Colors.filledMenuBackgroundEnabled: Color
    get() = if (isLight) AppColors.grayLight50 else AppColors.grayDark800

val Colors.filledMenuBackgroundHovered: Color
    get() = if (isLight) AppColors.grayLight200 else AppColors.grayDark700

val Colors.filledMenuBackgroundFocused: Color
    get() = if (isLight) AppColors.grayLight200 else AppColors.grayDark700

val Colors.filledMenuBackgroundDisabled: Color
    get() = if (isLight) AppColors.grayLight400 else AppColors.grayDark800


val Colors.filledMenuOutline: Color
    get() = if (isLight) AppColors.grayLight200 else AppColors.grayDark600

